import ic_face from './Recursos/Iconos/ic_face.svg'
import ic_insta from './Recursos/Iconos/ic_insta.svg'
import ic_tiktok from './Recursos/Iconos/ic_tiktok.svg'
import foto1 from './Recursos/Testimonios/foto1.png'
import foto2 from './Recursos/Testimonios/foto2.png'
import foto3 from './Recursos/Testimonios/foto3.png'
import foto4 from './Recursos/Testimonios/foto4.png'
import foto5 from './Recursos/Testimonios/foto5.png'


export const WASS = '3226486788'

export const REDES = [
    {
        img: ic_face,
        nombre: 'facebook',
        url: 'https://www.facebook.com/profile.php?id=100090500110787'
    },
    {
        img: ic_insta,
        nombre: 'instagram',
        url: 'https://www.instagram.com/j.goptica'
    },
    {
        img: ic_tiktok,
        nombre: 'tiktok',
        url: 'https://www.tiktok.com/@jgoptica01'
    },
]

export const CONTACTOS = [
    {
        nombre: 'Direccion',
        descripcion: 'Calle 19 #27-41 local 2, Pasto',
        url: 'https://www.google.com/maps/dir/?api=1&destination=1.217028,-77.2791,190&dir_action=navigate',

    },
    {
        nombre: 'Correo',
        descripcion: 'jgoptica01@gmail.com',
        url: 'mailto:jgoptica01@gmail.com',
    },
    {
        nombre: 'Telefono',
        descripcion: '322 6486788',
        url:  `https://api.whatsapp.com/send?phone=57${WASS}&text=Hola%20JG%20OPTICA`
        ,
    },
]

export const TESTIMONIOS =
    [
        {
            "nombre": "Ximena Hernández",
            "profesion": "Arquitecta",
            "testimonio": "El proceso de compra fue sumamente fluido y el envío llegó antes de lo esperado. Respecto al servicio, la asesoría para elegir la montura ideal y los lentes correctos hizo toda la diferencia. El armazón es extremadamente ligero y cómodo para usarlo frente a la computadora todo el día, y el ajuste en el puente nasal es perfecto sin dejar marcas.",
            "img": foto3
        },
        {
            "nombre": "Gerardo Ruiz",
            "profesion": "Chef",
            "testimonio": "Como profesional que pasa horas bajo luces intensas y calor, necesitaba unas gafas oftálmicas que resistieran el ritmo diario sin descuidar la estética. La experiencia en la tienda en línea fue muy intuitiva, con descripciones precisas de las medidas. Al recibirlas, la calidad de los materiales y los acabados superó mis expectativas por completo.",
            "img": foto1
        },
        {
            "nombre": "Sofía Villalobos",
            "profesion": "Diseñadora",
            "testimonio": "Me encantó el diseño de la montura, pero la calidad de los cristales graduados es lo que realmente vale la pena. La atención al cliente resolvió todas mis dudas sobre los tratamientos antirreflejo y de protección digital. El armazón es robusto pero con un estilo sumamente elegante y ligero. Es perfecto para el trabajo diario.",
            "img": foto3
        },
        {
            "nombre": "Alejandro Meza",
            "profesion": "Consultor",
            "testimonio": "Es la primera vez que compro lentes por internet y la consistencia en la graduación fue impecable. El empaque de protección para el envío es de los mejores que he visto, garantizando que el producto y el estuche llegaran intactos. El calce de las gafas es cómodo y no se deslizan al caminar. Una excelente compra.",
            "img": foto4
        },
        {
            "nombre": "Beatriz Alcántara",
            "profesion": "Abogada",
            "testimonio": "Buscaba unas gafas de sol con fórmula que combinaran formalidad y estilo, y la asesoría que recibí fue excelente. Terminamos eligiendo un diseño clásico con un perfil sofisticado que se adapta muy bien a cualquier atuendo ejecutivo. Los cristales tienen una claridad excepcional al conducir y la entrega llegó sin contratiempos.",
            "img": foto5
        }
    ]